import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { toggleValidityFilterEpic } from './_epics/toggleValidityFilter.epic';
import { resetValidityFilterEpic } from './_epics/resetValidityFilter.epic';

export const errorInvalidFilterEpic = safeCombineEpics(
  toggleValidityFilterEpic,
  resetValidityFilterEpic,
);
